import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { debounce } from '../../utils';
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input as AntInput,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
  Table,
  Pagination,
  Tabs,
  message,
} from 'antd';
import DoctorPracticeBulkAdd from './DoctorPracticeBulkAdd';

const { TabPane } = Tabs;
import { RegularText, SemiboldText } from '../../components/common/Text';
import { setDoctorProfile } from '../../actions/index';
import {
  fetchDoctorPracticeCenters,
  updatePracticeCenter,
  removePracticeForDoctor,
  fetchCenters,
  sendRequestForDoctorDetailsChanges,
  getDoctorPriceHistory,
  bulkUpdateDoctorPracticeStatus,
} from '../../services';

const { Paragraph, Text, Title } = Typography;
const { Option } = Select;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const PracticeText = styled(RegularText)`
  font-size: 14;
  color: #666569;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: column;
`;

const StatusDot = styled.div`
  float: left;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background: ${(props) => props.color || 'black'};
`;

// const Row = styled.div`
//   display: flex;
//   flex-direction: row;
// `;

// const Col = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   margin-right: 10px;
// `;

const columns = [
  {
    title: 'RequestId',
    dataIndex: 'requestId',
    key: 'requestId',
  },
  {
    title: 'Old OPD Charges',
    dataIndex: 'oldOpdCharges',
    key: 'oldOpdCharges',
  },
  {
    title: 'New OPD Charges',
    dataIndex: 'newOpdCharges',
    key: 'newOpdCharges',
  },
  {
    title: 'Old Offline Discount',
    dataIndex: 'oldOfflineDiscount',
    key: 'oldOfflineDiscount',
  },
  {
    title: 'New Offline Discount',
    dataIndex: 'newOfflineDiscount',
    key: 'newOfflineDiscount',
  },
  {
    title: 'Old Visit Payout Discount',
    dataIndex: 'oldPayoutOfflineDiscount',
    key: 'oldPayoutOfflineDiscount',
    render: (val) => val == null ? '-' : parseFloat(Number(val).toFixed(10)),
  },
  {
    title: 'New Visit Payout Discount',
    dataIndex: 'newPayoutOfflineDiscount',
    key: 'newPayoutOfflineDiscount',
    render: (val) => val == null ? '-' : parseFloat(Number(val).toFixed(10)),
  },
  {
    title: 'Old Offline Follow Up Days',
    dataIndex: 'oldofflineFollowUpDays',
    key: 'oldofflineFollowUpDays',
  },
  {
    title: 'New Offline Follow Up Days',
    dataIndex: 'newofflineFollowUpDays',
    key: 'newofflineFollowUpDays',
  },
  {
    title: 'Old Follow Up Offline Discount',
    dataIndex: 'oldOfflineFollowUpDiscount',
    key: 'oldOfflineFollowUpDiscount',
  },
  {
    title: 'New Follow Up Offline Discount',
    dataIndex: 'newOfflineFollowUpDiscount',
    key: 'newOfflineFollowUpDiscount',
  },
  {
    title: 'Request Status',
    dataIndex: 'status',
    key: 'status',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
  },
];
class DoctorPracticeCenterScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      practiceCenters: [],
      doctorPracticeId: null,
      networkCenterId: null,
      doctorPracticeActive: false,
      isRequestFromPluton: false,
      networkCenterTitle: '',
      networkCenterLocality: '',
      networkCenterStatus: 'not-live',
      emergencyNumber: '',
      opdCharges: '',
      onlineOpdCharges: '',
      previousOpdCharges: '',
      previousOnlineOpdCharges: '',
      priceChangeReason: '',
      inputReason: '',
      onlineDiscountOperation: 'percentage',
      onlineDiscount: '',
      offlineDiscountOperation: 'percentage',
      offlineDiscount: '',
      fDiscountOperation: 'percentage',
      fDiscount: '',
      fDays: '0',
      onlineFDiscountOperation: 'percentage',
      onlineFDiscount: '',
      onlineFDays: '0',
      payoutOfflineDiscount: '',
      payoutTo: 'center',
      formEditing: false,
      formSaving: false,
      formSavingLabel: 'Saving changes...',
      addCenterModalVisible: false,
      addedHealthCenter: { key: '', label: '' },
      fetchingCenters: false,
      fetchedHealthCenters: [],
      previousData: {},
      addingNewCenter: false,
      telehealth: false,
      previousTelehealth: false,
      previousDoctorPracticeActive: false,
      showingPriceHistory: false,
      doctorPriceHistory: [],
      page: 1,
      pageSize: 10,
      totalCenters: 0,
      allCenters: [],
      searchValue: undefined,
      searchOptions: [],
      searching: false,
      selectedCenterId: null,
      bulkStatus: 'pending',
      bulkUpdatingStatus: false,
      bulkResult: null,
      visitCommissionPercent: 0,
      offlinePayoutPercent: 100,
      enableVisitCommission: false,
    };
    console.log({ props });

    this.doctorId = props.doctorId;
    this.debouncedFetchHealthCenters = debounce(this.fetchHealthCenters, 600);
    this.searchTimer = null;
  }

  componentWillUnmount() {
    if (this.searchTimer) clearTimeout(this.searchTimer);
  }

  componentDidMount = () => {
    this.fetchPractice();
  };

  fetchPractice = () => {
    const { dispatch } = this.props;
    const { page, pageSize, selectedCenterId } = this.state;
    this.setState({ loading: true });
    fetchDoctorPracticeCenters(this.doctorId, page, pageSize, selectedCenterId)
      .then((res) => {
        const practiceCenters = res.practices;
        dispatch(setDoctorProfile({ practiceCenters }));
        this.setState({
          practiceCenters,
          totalCenters:
            res.totalCenters !== undefined
              ? res.totalCenters
              : (practiceCenters ? practiceCenters.length : 0),
          allCenters: Array.isArray(res.allCenters) ? res.allCenters : [],
        });
      })
      .finally(() => this.setState({ loading: false }));
  };

  goToPage = (nextPage) => {
    if (nextPage === this.state.page) return;
    this.setState({ page: nextPage }, this.fetchPractice);
  };

  confirmBulkUpdateAllCentersStatus = () => {
    const { bulkStatus, totalCenters, practiceCenters } = this.state;
    if (!bulkStatus) {
      message.warning('Pick a status to apply.');
      return;
    }
    const count = totalCenters || practiceCenters.length;
    Modal.confirm({
      title: 'Apply status to all centers?',
      style: { top: 80 },
      content: (
        <span>
          This will set onboarding status to{' '}
          <b>&quot;{bulkStatus}&quot;</b> on <b>all {count}</b> center
          {count === 1 ? '' : 's'} of this doctor. Continue?
        </span>
      ),
      okText: 'Yes, apply',
      cancelText: 'Cancel',
      okButtonProps: { style: { background: '#fa8c16', borderColor: '#fa8c16' } },
      onOk: this.bulkUpdateAllCentersStatus,
    });
  };

  bulkUpdateAllCentersStatus = () => {
    const { bulkStatus } = this.state;
    this.setState({ bulkUpdatingStatus: true });
    return bulkUpdateDoctorPracticeStatus(this.doctorId, bulkStatus)
      .then((res) => {
        const summary = (res && res.summary) || {};
        const results = (res && res.results) || [];
        const failed = results.filter((r) => r.status === 'failed');
        if (failed.length > 0) {
          this.setState({
            bulkResult: { status: bulkStatus, summary, results },
          });
        } else {
          message.success(
            `Updated ${summary.totalUpdated || 0} center${
              summary.totalUpdated === 1 ? '' : 's'
            } to "${bulkStatus}".`
          );
        }
        this.fetchPractice();
      })
      .catch((err) => {
        const data = err && err.response && err.response.data;
        const serverMsg =
          (data && data.err && Object.values(data.err)[0] && Object.values(data.err)[0].msg) ||
          (data && data.message && data.message !== 'Invalid fields' && data.message) ||
          'Bulk status update failed.';
        message.error(serverMsg);
      })
      .finally(() => this.setState({ bulkUpdatingStatus: false }));
  };

  closeBulkResult = () => this.setState({ bulkResult: null });

  downloadAllCentersCSV = () => {
    const { allCenters } = this.state;
    if (!allCenters || allCenters.length === 0) {
      message.warning('No centers available to download.');
      return;
    }
    const escapeCsv = (val) => {
      if (val === null || val === undefined) return '';
      const str = String(val);
      return /[",\n\r]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
    };
    const header = ['Center ID', 'Center Name', 'Doctor ID', 'Note'];
    const note = `Mapped to doctor #${this.doctorId}`;
    const rows = allCenters.map((c) => [
      escapeCsv(c.centerId),
      escapeCsv(c.centerName),
      escapeCsv(this.doctorId),
      escapeCsv(note),
    ]);
    const csv = [header.join(','), ...rows.map((r) => r.join(','))].join('\r\n');
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `doctor-${this.doctorId}-centers-${new Date()
      .toISOString()
      .slice(0, 10)}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    message.success(`Downloaded ${allCenters.length} center${allCenters.length === 1 ? '' : 's'}.`);
  };

  formatBulkReason = (reason) => {
    if (!reason) return 'Update failed.';
    const map = {
      SLOTS_NOT_FOUND: 'Slots not found — cannot go live.',
      INVALID_STATUS: 'Invalid target status.',
      NO_PRACTICE: 'No practice record found.',
    };
    if (map[reason]) return map[reason];
    return String(reason).replace(/_/g, ' ').toLowerCase();
  };

  centerNameById = (centerId) => {
    const found = (this.state.practiceCenters || []).find(
      (p) => p.centerId === centerId
    );
    return found ? found.centerName : null;
  };

  onPageChange = (nextPage) => {
    if (this.state.formEditing) {
      Modal.confirm({
        title: 'You are editing a center',
        content:
          'Switching pages will discard your unsaved edits. Continue?',
        okText: 'Discard and continue',
        cancelText: 'Stay',
        onOk: () => {
          this.cancelEditing();
          this.goToPage(nextPage);
        },
      });
      return;
    }
    this.goToPage(nextPage);
  };

  onSearchInputChange = (value) => {
    this.setState({ searchValue: value });
    if (this.searchTimer) clearTimeout(this.searchTimer);
    if (!value || !value.trim()) {
      this.setState({ searchOptions: [], searching: false });
      return;
    }
    this.setState({ searching: true });
    this.searchTimer = setTimeout(() => {
      fetchCenters(value.trim())
        .then((res) => {
          const options = (res.result || []).map((ele) => ({
            centerId: ele.centerId,
            title: ele.title,
            locality: ele.locality,
          }));
          this.setState({ searchOptions: options });
        })
        .finally(() => this.setState({ searching: false }));
    }, 400);
  };

  onSearchSelect = (centerId) => {
    const apply = () => {
      this.setState(
        {
          selectedCenterId: centerId,
          page: 1,
          searchValue: undefined,
          searchOptions: [],
        },
        this.fetchPractice
      );
    };
    if (this.state.formEditing) {
      Modal.confirm({
        title: 'You are editing a center',
        content:
          'Filtering will discard your unsaved edits. Continue?',
        okText: 'Discard and continue',
        cancelText: 'Stay',
        onOk: () => {
          this.cancelEditing();
          apply();
        },
      });
      return;
    }
    apply();
  };

  onClearFilter = () => {
    const apply = () => {
      this.setState(
        {
          selectedCenterId: null,
          page: 1,
          searchValue: undefined,
          searchOptions: [],
        },
        this.fetchPractice
      );
    };
    if (this.state.formEditing) {
      Modal.confirm({
        title: 'You are editing a center',
        content:
          'Clearing the filter will discard your unsaved edits. Continue?',
        okText: 'Discard and continue',
        cancelText: 'Stay',
        onOk: () => {
          this.cancelEditing();
          apply();
        },
      });
      return;
    }
    apply();
  };

  submit = () => {
    const {
      networkCenterId,
      doctorPracticeActive,
      opdCharges,
      onlineOpdCharges,
      previousOnlineOpdCharges,
      previousOpdCharges,
      priceChangeReason,
      offlineDiscount,
      offlineDiscountOperation,
      onlineDiscount,
      onlineDiscountOperation,
      fDiscount,
      fDiscountOperation,
      fDays,
      onlineFDiscount,
      onlineFDiscountOperation,
      onlineFDays,
      payoutOfflineDiscount,
      payoutTo,
      networkCenterStatus,
      onlineCorporatePayout,
      onlineRetailPayout,
      telehealth,
      previousTelehealth,
      previousDoctorPracticeActive,
      addingNewCenter,
      previousData,
      visitCommissionPercent,
      offlinePayoutPercent,
    } = this.state;
    if (offlineDiscountOperation === 'percentage' && (Number(offlineDiscount) || 0) > 100) {
      message.error('Offline Discount cannot be greater than 100%');
      return;
    }
    if (offlineDiscountOperation === 'percentage' && (Number(payoutOfflineDiscount) || 0) > 100) {
      message.error('Visit Payout Discount cannot be greater than 100%');
      return;
    }
    if ((Number(offlineDiscount) || 0) > (Number(payoutOfflineDiscount) || 0)) {
      message.error('Offline Discount cannot be greater than Visit Payout Discount');
      return;
    }
    if (offlineDiscountOperation === 'fixed' && Number(payoutOfflineDiscount) > Number(opdCharges)) {
      message.error('Visit Payout Discount (fixed) cannot be greater than doctor charges');
      return;
    }
    if (fDiscountOperation === 'fixed' && Number(fDiscount) > Number(opdCharges)) {
      message.error('Followup Discount (fixed) cannot be greater than doctor charges');
      return;
    }
    if (onlineDiscountOperation === 'fixed' && Number(onlineDiscount) > Number(onlineOpdCharges)) {
      message.error('Online Discount (fixed) cannot be greater than online doctor charges');
      return;
    }
    if (onlineFDiscountOperation === 'fixed' && Number(onlineFDiscount) > Number(onlineOpdCharges)) {
      message.error('Online Followup Discount (fixed) cannot be greater than online doctor charges');
      return;
    }
    if (
      !addingNewCenter &&
      !priceChangeReason &&
      previousDoctorPracticeActive === doctorPracticeActive &&
      previousTelehealth === telehealth &&
      Number(previousOnlineOpdCharges) === Number(onlineOpdCharges) &&
      Number(previousData.onlineDiscount || 0) === Number(onlineDiscount) &&
      (previousData.onlineDiscountOperation || 'percentage') === onlineDiscountOperation &&
      Number(previousData.onlineFDiscount || 0) === Number(onlineFDiscount) &&
      (previousData.onlineFDiscountOperation || 'percentage') === onlineFDiscountOperation &&
      Number(previousData.onlineFDays || 0) === Number(onlineFDays) &&
      Number(previousData.payoutOfflineDiscount || 0) === Number(payoutOfflineDiscount)
    ) {
      alert('Please enter price change reason!');
      return;
    }
    this.setState({ formSaving: true, formSavingLabel: 'Saving changes...' });
    console.log(previousDoctorPracticeActive, doctorPracticeActive);
    console.log(previousTelehealth, telehealth);
    console.log(previousOnlineOpdCharges, onlineOpdCharges);
    console.log(previousTelehealth, telehealth);
    console.log(previousData, onlineDiscount, onlineDiscount, onlineDiscountOperation, onlineFDiscount, onlineFDiscountOperation, onlineFDays);

    if (addingNewCenter) {
      updatePracticeCenter({
        doctorId: this.doctorId,
        centerId: networkCenterId,
        active: doctorPracticeActive,
        opdCharges,
        onlineOpdCharges,
        offlineDiscount,
        offlineDiscountOperation,
        onlineDiscount,
        onlineDiscountOperation,
        fDiscount,
        fDiscountOperation,
        fDays,
        onlineFDiscount,
        onlineFDiscountOperation,
        onlineFDays,
        payoutOfflineDiscount,
        fulfilmentType: payoutTo,
        status: networkCenterStatus,
        onlineCorporatePayout,
        onlineRetailPayout,
        telehealth,
        visitCommissionPercent,
        offlinePayoutPercent,
      })
        .then(() => {
          this.cancelEditing();
          this.fetchPractice();
        })
        .catch((err) => {
          console.log({ err });
          const errMsg = err?.data?.errorMessage || err?.response?.data?.errorMessage || 'Something went wrong. Please check your inputs and try again.';
          message.error(errMsg, 6);
        })
        .finally(() => {
          this.setState({ formSaving: false });
        });
    } else if (
      (previousDoctorPracticeActive !== doctorPracticeActive ||
      previousTelehealth !== telehealth ||
      Number(previousOnlineOpdCharges) !== Number(onlineOpdCharges) ||
      Number(previousData.onlineDiscount || 0) !== Number(onlineDiscount) ||
      (previousData.onlineDiscountOperation || 'percentage') !== onlineDiscountOperation ||
      Number(previousData.onlineFDiscount || 0) !== Number(onlineFDiscount) ||
      (previousData.onlineFDiscountOperation || 'percentage') !== onlineFDiscountOperation ||
      Number(previousData.onlineFDays || 0) !== Number(onlineFDays)) &&
      Number(opdCharges) === Number(previousData.opdCharges)
    ) {
      updatePracticeCenter({
        doctorId: this.doctorId,
        centerId: networkCenterId,
        active: doctorPracticeActive,
        opdCharges: previousData.opdCharges,
        onlineOpdCharges: onlineOpdCharges,
        offlineDiscount: previousData.offlineDiscount,
        offlineDiscountOperation: previousData.offlineDiscountOperation,
        onlineDiscount: onlineDiscount,
        onlineDiscountOperation: onlineDiscountOperation,
        fDiscount: previousData.fDiscount,
        fDiscountOperation: previousData.fDiscountOperation,
        fDays: previousData.fDays,
        onlineFDiscount: onlineFDiscount,
        onlineFDiscountOperation: onlineFDiscountOperation,
        onlineFDays: onlineFDays,
        payoutOfflineDiscount,
        fulfilmentType: previousData.fulfilmentType,
        status: previousData.status,
        onlineCorporatePayout,
        onlineRetailPayout,
        telehealth,
        visitCommissionPercent,
        offlinePayoutPercent,
      })
        .then(() => {
          this.cancelEditing();
          this.fetchPractice();
        })
        .catch((err) => {
          console.log({ err });
          const errMsg = err?.data?.errorMessage || err?.response?.data?.errorMessage || 'Something went wrong. Please check your inputs and try again.';
          message.error(errMsg, 6);
        })
        .finally(() => {
          this.setState({ formSaving: false });
        });
    } else {
      sendRequestForDoctorDetailsChanges({
        doctorId: this.doctorId,
        centerId: networkCenterId,
        active: doctorPracticeActive,
        opdCharges,
        onlineOpdCharges,
        offlineDiscount,
        offlineDiscountOperation,
        onlineDiscount,
        onlineDiscountOperation,
        fDiscount,
        fDiscountOperation,
        fDays,
        onlineFDiscount,
        onlineFDiscountOperation,
        onlineFDays,
        payoutOfflineDiscount,
        fulfilmentType: payoutTo,
        status: networkCenterStatus,
        onlineCorporatePayout,
        onlineRetailPayout,
        telehealth,
        visitCommissionPercent,
        offlinePayoutPercent,
        priceChangeReason:
          priceChangeReason === 'Other'
            ? this.state.inputReason
            : priceChangeReason,
        previousData,
        requestType: 'Price-Change-Request',
      })
        .then(() => {
          this.cancelEditing();
          this.fetchPractice();
        })
        .catch((err) => {
          console.log({ err });
          const errMsg = err?.data?.errorMessage || err?.response?.data?.errorMessage || 'Something went wrong. Please check your inputs and try again.';
          message.error(errMsg, 6);
        })
        .finally(() => {
          this.setState({ formSaving: false });
        });
    }
  };

  // deletePractice = doctorPracticeId => {
  //   deletePractice(this.doctorId, doctorPracticeId)
  //     .then(res => {
  //       message.success('Practice deleted successfully');
  //       this.fetchPractice();
  //     })
  //     .catch(err => {
  //       console.log({ err });
  //     });
  // };

  editPractice = (edu) => {
    this.setState({
      formEditing: true,
      doctorPracticeId: edu.doctorId || null,
      networkCenterId: edu.centerId || null,
      doctorPracticeActive: edu.active === 1,
      networkCenterTitle: edu.centerName || '',
      networkCenterLocality: edu.centerLocation || '',
      networkCenterStatus: edu.status || 'pending',
      opdCharges: edu.opdCharges || 0,
      onlineOpdCharges: edu.onlineOpdCharges || 0,
      previousOpdCharges: edu.opdCharges || 0,
      previousOnlineOpdCharges: edu.onlineOpdCharges || 0,
      offlineDiscountOperation: edu.offlineDiscountOperation || 'percentage',
      offlineDiscount:
        (edu.offlineDiscount !== null &&
          edu.offlineDiscount !== undefined &&
          edu.offlineDiscount) ||
        0,
      onlineDiscountOperation: edu.onlineDiscountOperation || 'percentage',
      onlineDiscount:
        (edu.onlineDiscount !== null &&
          edu.onlineDiscount !== undefined &&
          edu.onlineDiscount) ||
        0,
      fDiscountOperation: edu.fDiscountOperation || 'percentage',
      onlineFDiscountOperation: edu.onlineFDiscountOperation || 'percentage',
      fDiscount:
        (edu.fDiscount !== null &&
          edu.fDiscount !== undefined &&
          edu.fDiscount) ||
        0,
      onlineFDiscount:
        (edu.onlineFDiscount !== null &&
          edu.onlineFDiscount !== undefined &&
          edu.onlineFDiscount) ||
        0,
      fDays: (edu.fDays !== null && edu.fDays !== undefined && edu.fDays) || 0,
      onlineFDays:
        (edu.onlineFDays !== null &&
          edu.onlineFDays !== undefined &&
          edu.onlineFDays) ||
        0,
      payoutOfflineDiscount:
        (edu.payoutOfflineDiscount !== null &&
          edu.payoutOfflineDiscount !== undefined &&
          Number(edu.payoutOfflineDiscount)) ||
        0,
      payoutTo: edu.fulfilmentType || 'center',
      onlineCorporatePayout: edu.onlineCorporatePayout || 0,
      onlineRetailPayout: edu.onlineRetailPayout || 0,
      telehealth: edu.telehealth || false,
      previousTelehealth: edu.telehealth || false,
      previousDoctorPracticeActive: edu.active === 1,
      previousData: edu,
      ...(() => {
        const payout = Number(edu.payoutOfflineDiscount) || 0;
        const offline = Number(edu.offlineDiscount) || 0;
        if (payout > 0 && offline > 0) {
          const offlinePct = Math.min(100, Math.round((offline / payout) * 100));
          const commissionPct = 100 - offlinePct;
          return { offlinePayoutPercent: offlinePct, visitCommissionPercent: commissionPct, enableVisitCommission: commissionPct !== 0 };
        }
        return { visitCommissionPercent: 0, offlinePayoutPercent: 100, enableVisitCommission: false };
      })(),
    });
  };

  showPriceHistory = (edu) => {
    console.log('shgsf');
    getDoctorPriceHistory(this.doctorId, edu.centerId)
      .then((response) => {
        console.log(response);
        this.setState({
          doctorPriceHistory: response.priceHistory,
          showingPriceHistory: true,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ formSaving: false });
      });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (!prevState.formEditing && this.state.formEditing) {
      const el = document.getElementById('edit-form');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  cancelEditing = () => {
    this.setState({
      formEditing: false,
      doctorPracticeId: null,
      networkCenterId: null,
      doctorPracticeActive: '',
      networkCenterTitle: '',
      networkCenterAddress: '',
      networkCenterLocality: '',
      emergencyNumber: '',
      description: '',
      opdCharges: '',
      onlineOpdCharges: '',
      previousOnlineOpdCharges: '',
      previousOpdCharges: '',
      priceChangeReason: '',
      latitude: '',
      longitude: '',
      onlineFDiscountOperation: 'percentage',
      onlineFDiscount: '',
      onlineFDays: '0',
      payoutOfflineDiscount: '',
      visitCommissionPercent: 0,
      offlinePayoutPercent: 100,
      enableVisitCommission: false,
    });
  };

  onFromToDateChange = (date, dateString) => {
    console.log({ date, dateString });
    this.setState({
      fromDate: dateString[0],
      toDate: dateString[1],
    });
  };

  onPracticeActiveChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      doctorPracticeActive: e.target.checked,
    });
  };

  onEnableVisitCommissionChange = (e) => {
    const checked = e.target.checked;
    const visitCommissionPercent = checked ? 70 : 0;
    const offlinePayoutPercent = checked ? 30 : 100;
    const newOfflineDiscount = Math.round((this.state.payoutOfflineDiscount || 0) * (offlinePayoutPercent / 100) * 100) / 100;
    this.setState({ enableVisitCommission: checked, visitCommissionPercent, offlinePayoutPercent, offlineDiscount: newOfflineDiscount });
  };

  onVisitCommissionPercentChange = (e) => {
    const val = Math.min(100, Math.max(0, Number.parseFloat(e.target.value) || 0));
    const offlinePayoutPercent = 100 - val;
    const newOfflineDiscount = Math.round((this.state.payoutOfflineDiscount || 0) * (offlinePayoutPercent / 100) * 100) / 100;
    this.setState({ visitCommissionPercent: val, offlinePayoutPercent, offlineDiscount: newOfflineDiscount });
  };

  onRequestFromPluton = (e) => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({
      isRequestFromPluton: e.target.checked,
    });
  };

  onTelehealthActiveChange = (e) => {
    this.setState({
      telehealth: e.target.checked,
    });
  };

  removePractice = (edu) => {
    Modal.confirm({
      title: 'Confirm Removal',
      content: `Are you sure you want to remove ${edu.centerName} for this doctor?`,
      onOk: () => {
        this.setState({ formSaving: true, formSavingLabel: 'Removing center...' });
        removePracticeForDoctor(this.doctorId, edu.centerId)
          .then(() => {
            this.fetchPractice();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.setState({ formSaving: false });
          });
      },
    });
  };

  fetchHealthCenters = (val) => {
    this.setState({ fetchingCenters: true });
    if (val.trim() === '') {
      this.setState({
        fetchedHealthCenters: [],
        fetchingCenters: false,
      });
      return;
    }
    fetchCenters(val)
      .then((result) => {
        this.setState({
          fetchedHealthCenters: result.result.map((ele) => ({
            key: ele.centerId,
            locality: ele.locality,
            label: ele.title,
          })),
        });
      })
      .finally(() => {
        this.setState({
          fetchingCenters: false,
        });
      });
  };

  openPracticeProfile = (centerId) => () => {
    const { history } = this.props;
    history.push(`/center-profile/${centerId}`);
  };


  render() {
    const {
      addedHealthCenter,
      fetchedHealthCenters,
      fetchingCenters,
      loading,
      practiceCenters,
      networkCenterTitle,
      networkCenterLocality,
      networkCenterStatus,
      opdCharges,
      onlineOpdCharges,
      previousOnlineOpdCharges,
      previousOpdCharges,
      priceChangeReason,
      offlineDiscountOperation,
      offlineDiscount,
      onlineDiscountOperation,
      onlineDiscount,
      fDiscountOperation,
      fDiscount,
      fDays,
      onlineFDiscountOperation,
      onlineFDiscount,
      onlineFDays,
      payoutOfflineDiscount,
      payoutTo,
      formSaving,
      onlineRetailPayout,
      onlineCorporatePayout,
      telehealth,
      doctorPracticeActive,
      previousTelehealth,
      previousDoctorPracticeActive,
      addingNewCenter,
      previousData,
      showingPriceHistory,
      visitCommissionPercent,
      offlinePayoutPercent,
      page,
      pageSize,
      totalCenters,
      searchValue,
      searchOptions,
      searching,
      selectedCenterId,
      formSavingLabel,
    } = this.state;

    const practiceCentersForm = () => {
      const offlineDiscountType = (
        <Select
          value={offlineDiscountOperation}
          onChange={(e) => this.setState({ offlineDiscountOperation: e })}
        >
          <Option value="percentage">Percentage</Option>
          <Option value="fixed">Fixed Value</Option>
        </Select>
      );
      const onlineDiscountType = (
        <Select
          value={onlineDiscountOperation}
          onChange={(e) => this.setState({ onlineDiscountOperation: e })}
        >
          <Option value="percentage">Percentage</Option>
          <Option value="fixed">Fixed Value</Option>
        </Select>
      );
      const fDiscountType = (
        <Select
          value={fDiscountOperation}
          onChange={(e) => this.setState({ fDiscountOperation: e })}
        >
          <Option value="percentage">Percentage</Option>
          <Option value="fixed">Fixed Value</Option>
        </Select>
      );
      const onlineFDiscountType = (
        <Select
          value={onlineFDiscountOperation}
          onChange={(e) => this.setState({ onlineFDiscountOperation: e })}
        >
          <Option value="percentage">Percentage</Option>
          <Option value="fixed">Fixed Value</Option>
        </Select>
      );
      const payoutOfflineDiscountType = (
        <span
          style={{
            display: 'inline-block',
            padding: '0 11px',
            color: 'rgba(0, 0, 0, 0.65)',
          }}
        >
          {offlineDiscountOperation === 'fixed' ? 'Fixed Value' : 'Percentage'}
        </span>
      );
      const fieldBox = (color, label, content, hint) => (
        <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: 8, padding: '12px 14px' }}>
          <div style={{ fontSize: 11, fontWeight: 600, color, marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>{label}</div>
          {content}
          {hint && <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 5 }}>{hint}</div>}
        </div>
      );

      const sectionHeader = (color, title) => (
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
          <div style={{ width: 4, height: 16, background: color, borderRadius: 2, marginRight: 10 }} />
          <Text strong style={{ fontSize: 13, color: '#262626' }}>{title}</Text>
        </div>
      );

      return (
        <Card
          id="edit-form"
          bodyStyle={{ padding: 0, background: '#f5f6fa' }}
          style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid #e0e0e0', boxShadow: '0 4px 16px rgba(0,0,0,0.08)', marginBottom: 16 }}
        >
          <div style={{ background: 'linear-gradient(90deg, #5a3fc0, #7c4dff)', padding: '16px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Text strong style={{ color: '#fff', fontSize: 15 }}>Edit Practice Details</Text>
            {networkCenterTitle && (
              <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12 }}>
                {networkCenterTitle}{networkCenterLocality ? ` · ${networkCenterLocality}` : ''}
              </Text>
            )}
          </div>

          <div style={{ padding: '20px 24px' }}>

            {/* ── Center Info ── */}
            <div style={{ marginBottom: 24 }}>
              {sectionHeader('#1890ff', 'Center Information')}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  {fieldBox('#1890ff', 'Network Center Name',
                    networkCenterTitle === '' ? (
                      <Select
                        autoFocus
                        style={{ width: '100%' }}
                        labelInValue
                        filterOption={false}
                        value={addedHealthCenter}
                        placeholder="Search for a health center"
                        notFoundContent={fetchingCenters ? <Spin size="small" /> : null}
                        showSearch
                        onSearch={this.debouncedFetchHealthCenters}
                        onChange={(e, opt) => {
                          this.setState({
                            networkCenterId: Number.parseFloat(e.key),
                            networkCenterTitle: e.label,
                            networkCenterLocality: opt.props.locality,
                          });
                        }}
                      >
                        {fetchedHealthCenters.map((d) => (
                          <Option key={d.key} locality={d.locality}>{d.label} ({d.locality})</Option>
                        ))}
                      </Select>
                    ) : (
                      <AntInput disabled value={networkCenterTitle} placeholder="Network Center Title" />
                    )
                  )}
                </Col>
                <Col xs={24} md={12}>
                  {fieldBox('#1890ff', 'Network Center Locality',
                    <AntInput disabled value={networkCenterLocality} placeholder="Locality" />
                  )}
                </Col>
              </Row>
            </div>

            {/* ── OPD Charges ── */}
            <div style={{ marginBottom: 24 }}>
              {sectionHeader('#fa8c16', 'OPD Charges')}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  {fieldBox('#fa8c16', 'OPD Charges',
                    <AntInput
                      value={opdCharges}
                      onChange={(e) => this.setState({ opdCharges: Number.parseFloat(e.target.value) || 0 })}
                      placeholder="OPD Charges"
                    />
                  )}
                </Col>
                <Col xs={24} md={12}>
                  {fieldBox('#fa8c16', 'Online OPD Charges',
                    <AntInput
                      value={onlineOpdCharges}
                      onChange={(e) => this.setState({ onlineOpdCharges: Number.parseFloat(e.target.value) || 0 })}
                      placeholder="Online OPD Charges"
                    />
                  )}
                </Col>
              </Row>
            </div>

            {/* ── Discounts ── */}
            <div style={{ marginBottom: 24 }}>
              {sectionHeader('#52c41a', 'Discounts')}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  {fieldBox('#52c41a', 'Online Discount',
                    <AntInput
                      value={onlineDiscount}
                      addonBefore={onlineDiscountType}
                      onChange={(e) => this.setState({ onlineDiscount: Number.parseFloat(e.target.value) || 0 })}
                      placeholder="Online Discount"
                    />
                  )}
                </Col>
                <Col xs={24}>
                  <div style={{ background: 'linear-gradient(135deg, #f9f7ff 0%, #fffbf0 100%)', border: '1px solid #d3c8f5', borderRadius: 10, padding: '16px 18px 14px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14, borderBottom: '1px solid #e3deff', paddingBottom: 10 }}>
                      <Text strong style={{ fontSize: 13, color: '#5a3fc0' }}>Payout Configuration</Text>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <Checkbox checked={this.state.enableVisitCommission} onChange={this.onEnableVisitCommissionChange}>
                          <Text style={{ fontSize: 12 }}>Set Visit Commission (default 70/30)</Text>
                        </Checkbox>
                        <div style={{
                          background: visitCommissionPercent + offlinePayoutPercent === 100 ? '#f6ffed' : '#fff1f0',
                          border: `1px solid ${visitCommissionPercent + offlinePayoutPercent === 100 ? '#b7eb8f' : '#ffa39e'}`,
                          borderRadius: 20, padding: '2px 12px', fontSize: 12, fontWeight: 600,
                          color: visitCommissionPercent + offlinePayoutPercent === 100 ? '#52c41a' : '#f5222d',
                        }}>
                          {visitCommissionPercent}% + {offlinePayoutPercent}% = {visitCommissionPercent + offlinePayoutPercent}%
                        </div>
                      </div>
                    </div>
                    <Row gutter={[12, 12]}>
                      <Col xs={24} md={12}>
                        <div style={{ background: '#fff', border: '1px solid #d3c8f5', borderRadius: 8, padding: '12px 14px' }}>
                          <div style={{ fontSize: 11, fontWeight: 600, color: '#5a3fc0', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Visit Payout Discount (Center Discount)</div>
                          <AntInput
                            value={payoutOfflineDiscount}
                            addonBefore={offlineDiscountType}
                            onChange={(e) => {
                              const val = Number.parseFloat(e.target.value) || 0;
                              if (offlineDiscountOperation === 'percentage' && val > 100) {
                                message.error('Percentage value cannot be greater than 100%');
                                return;
                              }
                              const newOfflineDiscount = Math.round(val * (offlinePayoutPercent / 100) * 100) / 100;
                              this.setState({ payoutOfflineDiscount: val, offlineDiscount: newOfflineDiscount });
                            }}
                            placeholder="0"
                          />
                          <div style={{ fontSize: 11, color: '#8c8c8c', marginTop: 5 }}>Discount taken from the partner center</div>
                        </div>
                      </Col>
                      <Col xs={24} md={12}>
                        <div style={{ background: '#fffbe6', border: '1px solid #ffe58f', borderRadius: 8, padding: '12px 14px' }}>
                          <div style={{ fontSize: 11, fontWeight: 600, color: '#d48806', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Offline Discount (User Discount)</div>
                          <AntInput
                            value={offlineDiscount}
                            addonBefore={payoutOfflineDiscountType}
                            disabled
                            placeholder="0"
                          />
                          <div style={{ fontSize: 11, color: '#d48806', marginTop: 5 }}>Auto-calculated · Discount given to the patient</div>
                        </div>
                      </Col>
                      <Col xs={24} md={12}>
                        <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: '12px 14px' }}>
                          <div style={{ fontSize: 11, fontWeight: 600, color: '#389e0d', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>Visit Commission %</div>
                          <AntInput
                            value={visitCommissionPercent}
                            addonAfter="%"
                            disabled={!this.state.enableVisitCommission}
                            onChange={this.onVisitCommissionPercentChange}
                            placeholder="70"
                          />
                          <div style={{ fontSize: 11, color: '#52c41a', marginTop: 5 }}>This is the Visit Commission</div>
                        </div>
                      </Col>
                      <Col xs={24} md={12}>
                        <div style={{ background: '#fff0f6', border: '1px solid #ffadd2', borderRadius: 8, padding: '12px 14px' }}>
                          <div style={{ fontSize: 11, fontWeight: 600, color: '#c41d7f', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.5px' }}>User Discount %</div>
                          <AntInput
                            value={offlinePayoutPercent}
                            addonAfter="%"
                            disabled
                            placeholder="30"
                          />
                          <div style={{ fontSize: 11, color: '#eb2f96', marginTop: 5 }}>This is the Offline / User Discount</div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Follow Up ── */}
            <div style={{ marginBottom: 24 }}>
              {sectionHeader('#13c2c2', 'Follow Up')}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  {fieldBox('#13c2c2', 'Follow Up Discount',
                    <AntInput value={fDiscount} addonBefore={fDiscountType} onChange={(e) => this.setState({ fDiscount: Number.parseFloat(e.target.value) || 0 })} placeholder="Follow up Discount" />
                  )}
                </Col>
                <Col xs={24} md={12}>
                  {fieldBox('#13c2c2', 'Online Follow Up Discount',
                    <AntInput value={onlineFDiscount} addonBefore={onlineFDiscountType} onChange={(e) => this.setState({ onlineFDiscount: Number.parseFloat(e.target.value) || 0 })} placeholder="Online Follow up Discount" />
                  )}
                </Col>
                <Col xs={24} md={12}>
                  {fieldBox('#13c2c2', 'Follow Up Days',
                    <AntInput value={fDays} onChange={(e) => this.setState({ fDays: Number.parseInt(e.target.value) || 0 })} placeholder="Follow up Days" />
                  )}
                </Col>
                <Col xs={24} md={12}>
                  {fieldBox('#13c2c2', 'Online Follow Up Days',
                    <AntInput value={onlineFDays} onChange={(e) => this.setState({ onlineFDays: Number.parseInt(e.target.value) || 0 })} placeholder="Online Follow up Days" />
                  )}
                </Col>
              </Row>
            </div>

            {/* ── Settings ── */}
            <div style={{ marginBottom: 24 }}>
              {sectionHeader('#722ed1', 'Settings')}
              <Row gutter={[16, 12]}>
                <Col xs={24} md={12}>
                  {fieldBox('#722ed1', 'Payout To',
                    <Select style={{ width: '100%' }} value={payoutTo} onChange={(e) => this.setState({ payoutTo: e })}>
                      <Option value="doctor">Doctor</Option>
                      <Option value="center">Center</Option>
                    </Select>
                  )}
                </Col>
                <Col xs={24} md={12}>
                  {fieldBox('#722ed1', 'Onboarding Status',
                    <Select style={{ width: '100%' }} value={networkCenterStatus} onChange={(e) => this.setState({ networkCenterStatus: e })}>
                      <Option value="not-live">Not Live</Option>
                      <Option value="pending">Pending</Option>
                      <Option value="live">Live</Option>
                    </Select>
                  )}
                </Col>
                <Col xs={24} md={12}>
                  <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: 8, padding: '14px', display: 'flex', alignItems: 'center' }}>
                    <Checkbox checked={this.state.doctorPracticeActive} onChange={this.onPracticeActiveChange}>
                      <Text strong style={{ fontSize: 13 }}>Practice Center Active</Text>
                    </Checkbox>
                  </div>
                </Col>
                <Col xs={24} md={12}>
                  <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: 8, padding: '14px', display: 'flex', alignItems: 'center' }}>
                    <Checkbox checked={telehealth} onChange={this.onTelehealthActiveChange}>
                      <Text strong style={{ fontSize: 13 }}>Telehealth?</Text>
                    </Checkbox>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Online Payout (telehealth only) ── */}
            {telehealth && (
              <div style={{ marginBottom: 24 }}>
                {sectionHeader('#eb2f96', 'Online Payout')}
                <Row gutter={[16, 12]}>
                  <Col xs={24} md={12}>
                    {fieldBox('#eb2f96', 'Online Retail Payout',
                      <AntInput value={onlineRetailPayout} onChange={(e) => this.setState({ onlineRetailPayout: Number.parseInt(e.target.value) || 0 })} placeholder="Online Retail Payout" />
                    )}
                  </Col>
                  <Col xs={24} md={12}>
                    {fieldBox('#eb2f96', 'Online Corporate Payout',
                      <AntInput value={onlineCorporatePayout} onChange={(e) => this.setState({ onlineCorporatePayout: Number.parseInt(e.target.value) || 0 })} placeholder="Online Corporate Payout" />
                    )}
                  </Col>
                </Row>
              </div>
            )}

            {/* ── Reason for Change (conditional) ── */}
            {!(addingNewCenter || previousDoctorPracticeActive !== doctorPracticeActive || previousTelehealth !== telehealth) && (
              <div style={{ marginBottom: 24 }}>
                {sectionHeader('#fa541c', 'Reason for Change')}
                <div style={{ background: '#fff', border: '1px solid #e8e8e8', borderRadius: 8, padding: '12px 14px' }}>
                  <Select
                    style={{ width: '100%', marginBottom: priceChangeReason === 'Other' ? 10 : 0 }}
                    defaultValue="Select Reason"
                    onChange={(e) => this.setState({ priceChangeReason: e })}
                  >
                    <Option value="Fee got revised">Fee got revised</Option>
                    <Option value="Incorrect fee was updated in our system">Incorrect fee was updated in our system</Option>
                    <Option value="Incorrect price was informed by the centre while booking the appointment">Incorrect price was informed by the centre while booking the appointment</Option>
                    <Option value="Other">Other</Option>
                  </Select>
                  {priceChangeReason === 'Other' && (
                    <AntInput
                      value={this.state.inputReason}
                      onChange={(e) => this.setState({ inputReason: e.target.value })}
                      placeholder="Please enter your reason for changing doctor details"
                    />
                  )}
                </div>
              </div>
            )}

            {/* ── Action Buttons ── */}
            <Row gutter={[16, 0]}>
              <Col xs={24} md={12}>
                <Button
                  type="primary"
                  block
                  size="large"
                  disabled={formSaving}
                  style={{ background: '#5a3fc0', borderColor: '#5a3fc0', borderRadius: 8, fontWeight: 600 }}
                  onClick={this.submit}
                >
                  {addingNewCenter ||
                    previousDoctorPracticeActive !== doctorPracticeActive ||
                    previousTelehealth !== telehealth ||
                    Number(previousOnlineOpdCharges) !== Number(onlineOpdCharges) ||
                    Number(previousData.onlineDiscount || 0) !== Number(onlineDiscount) ||
                    (previousData.onlineDiscountOperation || 'percentage') !== onlineDiscountOperation ||
                    Number(previousData.onlineFDiscount || 0) !== Number(onlineFDiscount) ||
                    (previousData.onlineFDiscountOperation || 'percentage') !== onlineFDiscountOperation ||
                    Number(previousData.onlineFDays || 0) !== Number(onlineFDays)
                    ? 'Submit'
                    : 'Send for Approval'}
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Button block size="large" style={{ borderRadius: 8, fontWeight: 600 }} onClick={this.cancelEditing}>
                  Cancel
                </Button>
              </Col>
            </Row>

          </div>
        </Card>
      );
    };
    const renderPractice = (edu, idx) => {
      let statusColor = '#ffaf3c';
      switch (edu.status) {
        case 'not-live':
          statusColor = '#fe823a';
          break;
        case 'live':
          statusColor = '#00b7b7';
          break;
        case 'pending':
          statusColor = '#ffaf3c';
          break;
        default:
          break;
      }
      const renderStatus = (status) => {
        switch (status) {
          case 'not-live':
            return 'Not Live';
          case 'live':
            return 'Live';
          case 'pending':
            return 'Pending';
          default:
            return 'Pending';
        }
      };
      return (
        <Col key={idx} span={24}>
          <Card>
            <EduRowComponent>
              <Row type="flex" align="middle" justify="space-between">
                <Col>
                  <Row type="flex" align="middle" gutter={[16, 16]}>
                    <Col>
                      <Title level={4} style={{ margin: 0 }}>
                        {edu.centerName}
                      </Title>
                    </Col>
                    <Col>
                      <Button
                        icon="edit"
                        onClick={this.openPracticeProfile(edu.centerId)}
                      >
                        Want to edit center fulfilment? Edit Center
                      </Button>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row type="flex" align="middle">
                    <StatusDot color={statusColor} />
                    <Text
                      strong
                      style={{
                        color: statusColor,
                        marginLeft: '8px',
                      }}
                    >
                      {renderStatus(edu.status)}
                    </Text>
                  </Row>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Paragraph strong style={{ margin: 0 }}>
                    {edu.centerLocation}
                  </Paragraph>
                </Col>
              </Row>
              <Row style={{ marginBottom: '8px' }}>
                <Col span={12}>
                  <PracticeText as="span">
                    OPD Charges: <Text strong>{` ₹ ${edu.opdCharges}`}</Text>
                  </PracticeText>
                </Col>
                <Col span={12}>
                  <PracticeText as="span">
                    Online OPD Charges:{' '}
                    <Text strong>{` ₹ ${edu.onlineOpdCharges}`}</Text>
                  </PracticeText>
                </Col>
              </Row>
              <Row style={{ marginBottom: '8px' }}>
                <Col span={24}>
                  <Row>
                    <Col span={12}>
                      <Title level={4} strong>
                        Paying to:{' '}
                        {edu.fulfilmentType === 'center'
                          ? " Center's Account"
                          : " Doctor's Account"}
                      </Title>
                    </Col>
                    <Col span={12}>
                      <Row>
                        <Col>
                          <a
                            href={edu.inviteLink}
                            rel="noopener noreferrer"
                            target="_blank"
                          >
                            {edu.inviteLink}
                          </a>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Text code>{edu.slug}</Text>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row
                style={{ marginBottom: '8px' }}
                type="flex"
                align="middle"
                justify="space-between"
              >
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Offline Discount:</Text>
                      <Text>
                        {edu.offlineDiscountOperation === 'percentage'
                          ? ` ${edu.offlineDiscount}%`
                          : ` ₹ ${edu.offlineDiscount}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Online Discount:</Text>
                      <Text>
                        {edu.onlineDiscountOperation === 'percentage'
                          ? ` ${edu.onlineDiscount}%`
                          : ` ₹ ${edu.onlineDiscount}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row
                style={{ marginBottom: '8px' }}
                type="flex"
                align="middle"
                justify="space-between"
              >
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Visit Payout Discount:</Text>
                      <Text>
                        {edu.offlineDiscountOperation === 'percentage'
                          ? ` ${Number(edu.payoutOfflineDiscount) || 0}%`
                          : ` ₹ ${Number(edu.payoutOfflineDiscount) || 0}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row
                style={{ marginBottom: '8px' }}
                type="flex"
                align="middle"
                justify="space-between"
              >
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Followup Discount:</Text>
                      <Text>
                        {edu.fDiscountOperation === 'percentage'
                          ? ` ${edu.fDiscount}%`
                          : ` ₹ ${edu.fDiscount}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Online Followup Discount:</Text>
                      <Text>
                        {edu.onlineFDiscountOperation === 'percentage'
                          ? ` ${edu.onlineFDiscount}%`
                          : ` ₹ ${edu.onlineFDiscount}`}
                      </Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row
                style={{ marginBottom: '8px' }}
                type="flex"
                align="middle"
                justify="space-between"
              >
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Followup Days:</Text>
                      <Text>{edu.fDays}</Text>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col>
                      <Text strong>Online Followup Days:</Text>
                      <Text>{edu.onlineFDays}</Text>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row style={{ marginBottom: '8px' }}>
                <Col span={12}>
                  <Text strong>Is Doctor active in center?</Text>
                  <Text>{edu.active === 1 ? ' Yes' : ' No'}</Text>
                </Col>
                <Col span={12}>
                  <Text strong>Online Practice Active?</Text>
                  <Text>{edu.telehealth === 1 ? ' Yes' : ' No'}</Text>
                </Col>
              </Row>
              {edu.lastPrice && (
                <Row style={{ marginBottom: '8px' }}>
                  <Col span={12}>
                    <Text strong>Previous Price for Doctor:</Text>
                    <Text>{edu.lastPrice}</Text>
                  </Col>
                  <Col span={12}>
                    <Text strong>Last Updated:</Text>
                    <Text>
                      {edu.priceLastUpatedDate
                        ? new Date(edu.priceLastUpatedDate).toLocaleDateString()
                        : ''}
                    </Text>
                  </Col>
                </Row>
              )}
              <Row
                style={{
                  marginBottom: '10px',
                }}
              >
                <Col span={6}>
                  {showingPriceHistory ? (
                    <Button
                      block
                      type="primary"
                      style={{ marginRight: 10 }}
                      onClick={() =>
                        this.setState({
                          showingPriceHistory: false,
                        })
                      }
                    >
                      Close Price History Table
                    </Button>
                  ) : (
                    <Button
                      block
                      type="primary"
                      style={{ marginRight: 10 }}
                      onClick={() => this.showPriceHistory(edu)}
                    >
                      Show Doctor Price History
                    </Button>
                  )}
                </Col>
              </Row>
              {showingPriceHistory && (
                <Table
                  dataSource={this.state.doctorPriceHistory}
                  columns={columns}
                />
              )}
            </EduRowComponent>
            <Row gutter={24}>
              <Col xs={24} md={12}>
                <Button
                  block
                  type="primary"
                  style={{ marginRight: 10 }}
                  onClick={() => this.editPractice(edu)}
                >
                  Edit Charges
                </Button>
              </Col>
              <Col xs={24} md={12}>
                <Button
                  block
                  type="danger"
                  style={{ marginRight: 10 }}
                  onClick={() => this.removePractice(edu)}
                >
                  Remove practice for doctor
                </Button>
              </Col>
              {/* <Popconfirm
            department="Are you sure delete this?"
            onConfirm={() => this.deletePractice(edu.doctorPracticeId)}
            // onCancel={cancel}
            okText="Yes"
            cancelText="No">
            <Button type="danger">Delete</Button>
          </Popconfirm> */}
            </Row>
          </Card>
        </Col>
      );
    };

    const renderHeader = () => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 16,
          padding: '14px 18px',
          background: '#ffffff',
          border: '1px solid #e7e7e7',
          borderRadius: 6,
          marginBottom: 16,
          boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
          flexWrap: 'wrap',
        }}
      >
        <div style={{ flex: '1 1 320px', minWidth: 240 }}>
          <Select
            showSearch
            allowClear
            value={searchValue}
            placeholder="Search centers by name or ID"
            notFoundContent={searching ? <Spin size="small" /> : null}
            filterOption={false}
            onSearch={this.onSearchInputChange}
            onChange={(val) => {
              if (val === undefined) this.onClearFilter();
              else this.onSearchSelect(val);
            }}
            style={{ width: '100%' }}
            optionLabelProp="label"
          >
            {searchOptions.map((opt) => (
              <Option
                key={opt.centerId}
                value={opt.centerId}
                label={`${opt.title} (#${opt.centerId})`}
              >
                <div style={{ display: 'flex', flexDirection: 'column', padding: '2px 0' }}>
                  <span style={{ fontWeight: 500, color: '#514f54' }}>
                    {opt.title}{' '}
                    <span style={{ color: '#9b9b9b', fontWeight: 400, fontSize: 12 }}>
                      #{opt.centerId}
                    </span>
                  </span>
                  {opt.locality && (
                    <span style={{ fontSize: 12, color: '#7c7c7c' }}>{opt.locality}</span>
                  )}
                </div>
              </Option>
            ))}
          </Select>
          {selectedCenterId && (
            <div style={{ marginTop: 8, fontSize: 12, color: '#7c7c7c' }}>
              Filtered to center #{selectedCenterId}.{' '}
              <a onClick={this.onClearFilter} style={{ color: '#7651da' }}>
                Clear filter
              </a>
            </div>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '8px 14px',
            background: '#fff7e6',
            border: '1px solid #ffe7ba',
            borderRadius: 6,
          }}
        >
          <div style={{ fontSize: 12, fontWeight: 600, color: '#514f54' }}>
            Bulk shift status:
          </div>
          <Select
            value={this.state.bulkStatus}
            onChange={(v) => this.setState({ bulkStatus: v })}
            style={{ width: 130 }}
            disabled={this.state.bulkUpdatingStatus}
          >
            <Option value="pending">Pending</Option>
            <Option value="not-live">Not Live</Option>
            <Option value="live">Live</Option>
          </Select>
          <Button
            type="primary"
            loading={this.state.bulkUpdatingStatus}
            disabled={loading || (totalCenters || practiceCenters.length) === 0}
            onClick={this.confirmBulkUpdateAllCentersStatus}
            style={{ background: '#fa8c16', borderColor: '#fa8c16' }}
          >
            Apply to all
          </Button>
        </div>
        {(() => {
          const allCentersCount = (this.state.allCenters || []).length;
          const isDownloadable =
            !loading && !selectedCenterId && allCentersCount > 0;
          const tileBase = {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '8px 14px',
            background: '#f6f3ff',
            border: '1px solid #d9c8ff',
            borderRadius: 6,
            minWidth: 140,
            transition: 'box-shadow 0.15s ease, transform 0.15s ease',
          };
          const tileInteractive = isDownloadable
            ? {
                cursor: 'pointer',
                boxShadow: '0 1px 2px rgba(118,81,218,0.12)',
              }
            : { cursor: 'default' };
          return (
            <div
              role={isDownloadable ? 'button' : undefined}
              tabIndex={isDownloadable ? 0 : undefined}
              title={
                isDownloadable
                  ? 'Click to download all centers as CSV'
                  : selectedCenterId
                  ? 'Clear the filter to download all centers'
                  : undefined
              }
              onClick={isDownloadable ? this.downloadAllCentersCSV : undefined}
              onKeyDown={(e) => {
                if (
                  isDownloadable &&
                  (e.key === 'Enter' || e.key === ' ')
                ) {
                  e.preventDefault();
                  this.downloadAllCentersCSV();
                }
              }}
              style={{ ...tileBase, ...tileInteractive }}
            >
              <div
                style={{
                  minWidth: 36,
                  height: 36,
                  padding: '0 10px',
                  borderRadius: 18,
                  background: '#7651da',
                  color: '#ffffff',
                  fontWeight: 600,
                  fontSize: 16,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {loading
                  ? '…'
                  : selectedCenterId
                  ? practiceCenters.length
                  : totalCenters}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 600,
                    color: '#514f54',
                  }}
                >
                  {selectedCenterId ? 'Filtered' : 'Total Centers'}
                </div>
                {isDownloadable && (
                  <div
                    style={{
                      fontSize: 11,
                      color: '#7651da',
                      fontWeight: 500,
                      marginTop: 2,
                    }}
                  >
                    ⬇ Download CSV
                  </div>
                )}
              </div>
            </div>
          );
        })()}
      </div>
    );

    const { bulkResult } = this.state;
    const failedResults = bulkResult
      ? (bulkResult.results || []).filter((r) => r.status === 'failed')
      : [];
    const updatedResults = bulkResult
      ? (bulkResult.results || []).filter((r) => r.status === 'updated')
      : [];

    return (
      <React.Fragment>
        <Modal
          title="Bulk status update — partial result"
          visible={!!bulkResult}
          style={{ top: 80 }}
          onOk={this.closeBulkResult}
          onCancel={this.closeBulkResult}
          okText="Got it"
          cancelButtonProps={{ style: { display: 'none' } }}
          width={620}
        >
          {bulkResult && (
            <div>
              <div style={{ marginBottom: 12 }}>
                Target status: <b>&quot;{bulkResult.status}&quot;</b>
                {' · '}
                Updated: <b>{bulkResult.summary.totalUpdated || 0}</b>
                {' · '}
                Skipped: <b>{bulkResult.summary.totalSkipped || 0}</b>
                {' · '}
                <span style={{ color: '#cf1322' }}>
                  Failed: <b>{bulkResult.summary.totalFailed || 0}</b>
                </span>
              </div>
              {failedResults.length > 0 && (
                <div
                  style={{
                    border: '1px solid #ffa39e',
                    background: '#fff1f0',
                    borderRadius: 4,
                    padding: 10,
                    marginBottom: 12,
                  }}
                >
                  <div style={{ fontWeight: 600, marginBottom: 6, color: '#cf1322' }}>
                    Could not change status for these centers:
                  </div>
                  {failedResults.map((r) => {
                    const name = this.centerNameById(r.centerId);
                    return (
                      <div
                        key={r.centerId}
                        style={{ fontSize: 13, marginBottom: 4, color: '#514f54' }}
                      >
                        <span style={{ fontWeight: 500 }}>
                          {name || `Center #${r.centerId}`}{' '}
                          <span style={{ color: '#9b9b9b', fontWeight: 400 }}>
                            #{r.centerId}
                          </span>
                        </span>
                        {' — '}
                        <span style={{ color: '#cf1322' }}>
                          {this.formatBulkReason(r.reason)}
                        </span>
                      </div>
                    );
                  })}
                </div>
              )}
              {updatedResults.length > 0 && (
                <div style={{ fontSize: 12, color: '#7c7c7c' }}>
                  {updatedResults.length} center
                  {updatedResults.length === 1 ? '' : 's'} updated successfully.
                </div>
              )}
            </div>
          )}
        </Modal>
        <Tabs defaultActiveKey="manage" animated={false}>
        <TabPane tab="Manage Centers" key="manage">
      <Row type="flex" align="middle" gutter={[16, 16]}>
          <React.Fragment>
            <Col span={24}>{renderHeader()}</Col>
            <Col span={24}>
              <Title type={2}>Practice Centers</Title>
            </Col>
            {loading ? (
              <div>
                <Spin />
              </div>
            ) : (
              <Col span={24}>{practiceCenters.map(renderPractice)}</Col>
            )}
            {!selectedCenterId && totalCenters > pageSize && (
              <Col span={24} style={{ padding: '12px 0', textAlign: 'right' }}>
                <Pagination
                  current={page}
                  pageSize={pageSize}
                  total={totalCenters}
                  showSizeChanger={false}
                  onChange={this.onPageChange}
                />
              </Col>
            )}
            {!this.state.formEditing && (
              <Col span={24}>
                <Button
                  style={{ alignSelf: 'center', flex: 0, padding: 4 }}
                  onClick={() => {
                    this.editPractice({});
                    this.setState({ addingNewCenter: true });
                  }}
                >
                  Add Practice Center
                </Button>
              </Col>
            )}
            <Col span={24}>
              {this.state.formEditing && practiceCentersForm()}
            </Col>
          </React.Fragment>
      </Row>
        </TabPane>
        <TabPane tab="Bulk Add Centers" key="bulk">
          <DoctorPracticeBulkAdd
            doctorId={this.doctorId}
            onSuccess={() => this.fetchPractice()}
          />
        </TabPane>
      </Tabs>

      {formSaving && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.45)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 12,
              padding: '36px 52px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
              minWidth: 220,
            }}
          >
            <Spin size="large" />
            <div
              style={{
                marginTop: 18,
                color: '#5a3fc0',
                fontWeight: 600,
                fontSize: 15,
                letterSpacing: '0.2px',
              }}
            >
              {formSavingLabel}
            </div>
          </div>
        </div>
      )}

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
});

export default withRouter(connect(mapStateToProps)(DoctorPracticeCenterScreen));
